import React from 'react'
import {
  makeStyles,
  createStyles,
  Dialog,
  useTheme,
  Typography,
} from '@material-ui/core'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SwiperOptions } from 'swiper/types/swiper-options'
import CMSText, { isPrismicText, prismicText } from '../Global/CMSText'
SwiperCore.use([Pagination, Scrollbar, A11y])

const useStyles = makeStyles((theme) =>
  createStyles({
    slide: {
      width: 350,
      minHeight: 400,
      padding: theme.spacing(4, 2),
      [theme.breakpoints.down('md')]: {
        width: 'auto',
        minHeight: 350,
      },
    },
    slideContent: {
      minHeight: 350,
      [theme.breakpoints.down('md')]: {
        minHeight: 280,
      },
    },
    imageSlide: {
      width: 'auto',
      height: 180,
      [theme.breakpoints.down('md')]: {
        height: 80,
      },
    },
    imageSlideContainer: {
      textAlign: 'center',
    },
    textContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    numberSlide: {
      border: '1px solid black',
      borderRadius: 15,
      textAlign: 'center',
      marginRight: theme.spacing(0.5),
      width: 20,
    },
    slideTitle: {
      [theme.breakpoints.down('md')]: {
        //fontSize: 14,
      },
    },
  })
)

type Tprops = {
  open: boolean
  handleCloseModal: any
  t: any
  slides: any
  title: string
}

const SwiperModal = ({ open, handleCloseModal, slides, title, t }: Tprops) => {
  const classes = useStyles()
  const theme = useTheme()

  const swiperParams: SwiperOptions = {
    pagination: { clickable: true },
    autoHeight: true,
    spaceBetween: theme.spacing(1),
    slidesPerView: 1,
    slidesPerGroup: 1,
  }

  return (
    <>
      <Dialog open={open} onClose={handleCloseModal}>
        <div className={classes.slide}>
          <Typography
            variant={'h3'}
            color={'primary'}
            gutterBottom
            align={'center'}
            className={classes.slideTitle}
          >
            {title}
          </Typography>
          <Swiper {...swiperParams}>
            {slides
              ? slides.map((slide, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div className={classes.slideContent}>
                        {slide.imageslide.url && (
                          <div className={classes.imageSlideContainer}>
                            <img
                              src={slide.imageslide.url}
                              className={classes.imageSlide}
                            />
                          </div>
                        )}
                        <div className={classes.textContainer}>
                          <div>
                            <Typography
                              variant={'body2'}
                              className={classes.numberSlide}
                            >
                              {index + 1}
                            </Typography>
                          </div>
                          <div>
                            {isPrismicText(slide.titleslide) && (
                              <Typography variant={'body2'} gutterBottom>
                                <b>{prismicText(slide?.titleslide)}</b>
                              </Typography>
                            )}
                            {isPrismicText(slide.paragraph_slide) && (
                              <Typography variant={'body2'}>
                                <CMSText data={slide?.paragraph_slide} />
                              </Typography>
                            )}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                })
              : [0, 1, 2].map((key, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div className={classes.slideContent}>
                        <div className={classes.imageSlideContainer}>
                          <img
                            src={'/images/placeholder.jpg'}
                            className={classes.imageSlide}
                          />
                        </div>
                        <div className={classes.textContainer}>
                          <div>
                            <Typography
                              variant={'body2'}
                              className={classes.numberSlide}
                            >
                              {index + 1}
                            </Typography>
                          </div>
                          <div>
                            <Typography variant={'body2'} gutterBottom>
                              <b>{t('texts:general:add_a_text')}</b>
                            </Typography>
                            <Typography variant={'body2'}>
                              {t('texts:general:add_a_description')}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                })}
          </Swiper>
        </div>
      </Dialog>
    </>
  )
}

export default SwiperModal
